import { useColorModeValue, useToast } from "@chakra-ui/react";
import React from "react";
import { QuoteApi } from "../api/QuoteApi";
import QuoteTableContainer from "../components/QuoteTableContainer";
import useUser from "../hooks/useUser";
import { Quote } from "../lib/models/quote.model";
import { QuoteUtils } from "../lib/quote-utils";

function MyQuotesView() {
  const [quotes, setQuotes] = React.useState<Quote[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const { user } = useUser();
  const toast = useToast();
  const toastVariant = useColorModeValue("subtle", "solid");

  const fetchQuotes = React.useCallback(() => {
    setLoading(true);

    if (!user?.email) {
      return;
    }

    QuoteApi.getQuotes({ username: user?.email, allquotes: false })
      .then((res) => {
        const activeQuotes = res.data.map((x) => {
          x.quoteTypeLabel = QuoteUtils.PrettyPrintQuoteType(x.quoteType);
          x.createdBy = `${x.firstname} ${x.lastname}`;
          return x;
        });

        setQuotes(activeQuotes);
      })
      .catch((err) => {
        toast({
          title: "Unable to Load Quotes",
          description: "An error has occurred when attempting to fetch quotes",
          status: "error",
          variant: toastVariant,
          isClosable: true,
          position: "top-right",
        });
      })
      .finally(() => setLoading(false));
  }, [setQuotes, user, toast, toastVariant]);

  React.useEffect(() => {
    fetchQuotes();
  }, [fetchQuotes]);

  return (
    <QuoteTableContainer
      quotes={quotes}
      refetchQuotes={fetchQuotes}
      loading={loading}
      title="My Quotes"
    />
  );
}

export default MyQuotesView;
